import { METRIC_TYPE } from '../consts/graphTypes';
import { getMetricsGroupByV3 } from '../../custom-metrics-api.facade';
import {
  METRICS_GROUP_BY_API_PARAMS,
  getCalculatedValue
} from '../../custom-report.serivce';
import { isMedianMetric } from '../../custom-report.util';
import { getMappedV3Data } from 'common/services/metrics.service';
import { getFormattedAndCalculatedV3Data } from 'views/root/views/home/views/dashboard/GroupDashboard/groupDashboard.service';
import { getAllContributorsTeam } from 'common/utils/utils';
import _ from 'lodash';

const getCheckGraphTypeList = ({
  graph,
  isPmCustomDashboard,
  isTeamGoals,
  isEditable
}) => [
  {
    check: Boolean(graph.internal_type ?? graph.metricType),
    value: graph.internal_type ?? graph.metricType
  },
  {
    check: Boolean(isPmCustomDashboard),
    value: METRIC_TYPE.pm
  },
  {
    check: Boolean(isTeamGoals),
    value: METRIC_TYPE.goals
  },
  {
    check: Boolean(isEditable),
    value: METRIC_TYPE.custom
  }
];

export const getTotalsV3Value = ({
  percentOff,
  metricsForAvg,
  v3MetricsTotalValue
}) => {
  if (percentOff?.metrics?.[0]?.name) {
    const percentOffMetricName = percentOff?.metrics?.[0]?.name;
    const percentOffMetricValue =
      metricsForAvg?.[0]?.[percentOffMetricName] ?? 1;
    return percentOffMetricValue === 0 || !v3MetricsTotalValue
      ? 0
      : _.min([(v3MetricsTotalValue / percentOffMetricValue) * 100, 100]);
  }
  return v3MetricsTotalValue;
};

export const getMetricType = ({ graph, ...rest }) => {
  const graphTypes = getCheckGraphTypeList({ graph, ...rest });
  for (const type of graphTypes) {
    if (type.check) {
      return type.value;
    }
  }
  return METRIC_TYPE.default;
};

export const addMetricsAggregation = ({
  metricsCalculationConfig: { metricsCalculationStrategy },
  graph: { metrics, agg: graphAgg }
}) => {
  return metrics.map(metric => {
    const agg = graphAgg || metricsCalculationStrategy;
    return {
      ...metric,
      ...(graphAgg || isMedianMetric(metric.name) ? { agg } : {})
    };
  });
};

export const metricsByLabels = ({ metrics = [], graph, filters }) => {
  return metrics.map(metric => {
    const totals = metric?.total || {};
    const data = metric?.data ?? [];
    const dataMappedToV3 = data.map(item =>
      getMappedV3Data({
        v3DataResult: item
      })
    );
    const { formattedV3Data } = getFormattedAndCalculatedV3Data(
      totals,
      [graph.metrics[0].name],
      [graph],
      dataMappedToV3
    );
    return {
      group: metric?.group,
      data,
      total: formattedV3Data
    };
  });
};

export const metricsByGroups = ({ metrics = [], graph, filters }) => {
  const v3GroupBy = getMetricsGroupByV3(filters, graph.reportDefinition);

  const groups = [METRIC_TYPE.pm, METRIC_TYPE.reported].includes(
    graph.metricType
  )
    ? [graph.id]
    : v3GroupBy.apiParam === METRICS_GROUP_BY_API_PARAMS.TEAM &&
      _.isEmpty(getAllContributorsTeam(filters.globallySelectedTeams))
    ? filters.globallySelectedTeams.map(({ id }) => id)
    : [metrics?.[0]?.group].filter(Boolean);
  const metricsByGroup = metrics.reduce((acc, curr) => {
    if (curr.data) {
      acc[curr.group] = { data: curr.data, total: curr.total };
    }
    return acc;
  }, {});
  return groups.map(group => {
    const totals = metricsByGroup[group]?.total || {};
    const data = metricsByGroup[group]?.data ?? [];
    const dataMappedToV3 = data.map(item =>
      getMappedV3Data({
        v3DataResult: item
      })
    );
    const { formattedV3Data } = getFormattedAndCalculatedV3Data(
      totals,
      [graph.metrics[0].name],
      [graph],
      dataMappedToV3
    );
    return {
      group,
      data,
      total: formattedV3Data
    };
  });
};

export const getPercentOffValue = (
  percentOff,
  mainMetric,
  avgOnlyWhenDataAvailable,
  metricsForAvg
) =>
  percentOff &&
  getCalculatedValue(
    mainMetric.name,
    null,
    avgOnlyWhenDataAvailable,
    null,
    metricsForAvg
  );
